// Shared keyboard-focus indicator: every focusable kit element draws the same `focus-ring` outline
// (palette `--focus-ring` = primary-strong), so focus reads identically across components.

/** Outline just outside the element's box. */
export const FOCUS_RING =
  "outline-none focus-visible:outline-2 focus-visible:outline-offset-1 focus-visible:outline-noa-focus-ring";

/** Outline drawn inside the box — for full-bleed rows (Collapse headers) where an outer ring would be clipped. */
export const FOCUS_RING_INSET =
  "outline-none focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-noa-focus-ring";
